import { Quotas, Survey } from '../../../shared/interfaces/survey.interface';
import { QuotaOption, SelectedQuotaOption } from './selected-quota-option';

interface SelectedQuota {
  enabled: () => boolean;
  quotaOptions: () => QuotaOption[];
}

export class AidaSelectedQuota implements SelectedQuota {
  constructor(
    private readonly _survey: Survey,
    private readonly _quotas: Quotas[] = []
  ) {}

  public enabled(): boolean {
    return !!(
      this._survey.aida?.enabled && this._survey.aida.selected_quota_ids?.length
    );
  }

  public quotaOptions(): QuotaOption[] {
    return new SelectedQuotaOption(
      this._quotas,
      this._survey.aida?.selected_quota_ids || []
    ).ids();
  }
}

export class QbpSelectedQuota implements SelectedQuota {
  constructor(
    private readonly _survey: Survey,
    private readonly _quotas: Quotas[] = []
  ) {}

  public enabled(): boolean {
    return !!(
      this._survey.is_qbp_enable && this._survey.qbp?.selectedQuotaIds?.length
    );
  }

  public quotaOptions(): QuotaOption[] {
    return new SelectedQuotaOption(
      this._quotas,
      this._survey.qbp.selectedQuotaIds || []
    ).ids();
  }
}
